module.exports = __webpack_public_path__ + "img/header_mob.6951520.jpg";